// UnauthorizedPage.js
import React from 'react';
import { Typography, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const UnauthorizedPage = () => {
    const navigate = useNavigate();

    const handleBackToLogin = () => {
        navigate('/');
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <Title level={2}>Access Denied</Title>
            <Text>You do not have the required roles to access this application.</Text>
            <br />
            <Button type="primary" onClick={handleBackToLogin} style={{ marginTop: '20px' }}>
                Back to Login
            </Button>
        </div>
    );
};

export default UnauthorizedPage;
